export interface MenuItem {
  id: string;
  name: string;
  icon: string;
  costPrice: number;    // Giá vốn
  sellPrice: number;    // Giá bán
  profit: number;       // Tiền lời = sellPrice - costPrice
  unlocked: boolean;
  requiredRep: number;  // Điểm uy tín để mở khóa
  desc: string;
  region?: 'north' | 'central' | 'south' | 'all';
  shelfLife: 'storable' | 'perishable_drink' | 'packaged'; // 'storable': cà phê, sữa, chanh, trà mạn cất giữ được không thiu bỏ; 'perishable_drink': nước mía, nước sâm, chè pha sẵn qua đêm bị thiu; 'packaged': đồ khô/lon
}

export type RegionKey = 'north' | 'central' | 'south';
export type SpotType = 'tourist' | 'office' | 'school' | 'residential';

// Base regional menus — 100% Đồ Sẵn, Ướp Lạnh & Đóng Gói (KHÔNG Bếp Nấu Nướng)
export const REGIONAL_BASE_MENUS: Record<RegionKey, MenuItem[]> = {
  north: [
    {
      id: 'tra_da',
      name: 'Trà Đá Mạn',
      icon: '🧊',
      costPrice: 1_000,
      sellPrice: 5_000,
      profit: 4_000,
      unlocked: true,
      requiredRep: 0,
      desc: 'Trà mạn Thái Nguyên chát dịu ướp lạnh, giải nhiệt trưa hè',
      region: 'north',
      shelfLife: 'storable',
    },
    {
      id: 'nhan_tran',
      name: 'Nhân Trần Hè Phố',
      icon: '🌿',
      costPrice: 1_200,
      sellPrice: 5_000,
      profit: 3_800,
      unlocked: true,
      requiredRep: 0,
      desc: 'Nước lá ngọt mát ủ lạnh, vị đượm họng dân dã',
      region: 'north',
      shelfLife: 'storable',
    },
    {
      id: 'tra_chanh',
      name: 'Trà Chanh Phố Cổ',
      icon: '🍋',
      costPrice: 4_500,
      sellPrice: 12_000,
      profit: 7_500,
      unlocked: true,
      requiredRep: 0,
      desc: 'Trà chanh pha sẵn chua ngọt mát lạnh ven hồ',
      region: 'north',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'nuoc_mia',
      name: 'Nước Mía Siêu Sạch',
      icon: '🎋',
      costPrice: 5_000,
      sellPrice: 10_000,
      profit: 5_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Mía ngọt lịm thơm quất ép sẵn ướp lạnh tức thì',
      region: 'north',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'huong_duong',
      name: 'Đĩa Hướng Dương',
      icon: '🌻',
      costPrice: 8_500,
      sellPrice: 15_000,
      profit: 6_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Gói hướng dương cắn tí tách, giữ chân khách buôn chuyện',
      region: 'north',
      shelfLife: 'packaged',
    },
    {
      id: 'sau_da',
      name: 'Nước Sấu Đá Chua Ngọt',
      icon: '🍏',
      costPrice: 6_500,
      sellPrice: 15_000,
      profit: 8_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Sấu ngâm gừng Hà Nội chua ngọt giòn sần sật',
      region: 'north',
      shelfLife: 'storable',
    },
    {
      id: 'ca_phe_sua',
      name: 'Cà Phê Sữa Nâu Đá',
      icon: '☕',
      costPrice: 8_000,
      sellPrice: 18_000,
      profit: 10_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Phin đậm đà ngọt béo pha sẵn ủ lạnh',
      region: 'north',
      shelfLife: 'storable',
    },
    {
      id: 'banh_mi_que',
      name: 'Bánh Mì Que Hải Phòng',
      icon: '🥖',
      costPrice: 10_500,
      sellPrice: 18_000,
      profit: 7_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Pate béo ngậy ớt chí chương giòn tan đóng gói',
      region: 'north',
      shelfLife: 'packaged',
    },
    {
      id: 'tra_tac_khong_lo',
      name: 'Trà Tắc Khổng Lồ',
      icon: '🍊',
      costPrice: 5_000,
      sellPrice: 15_000,
      profit: 10_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bình trà tắc chua ngọt đã khát giải nhiệt hè',
      region: 'north',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'nem_chua_ran',
      name: 'Nem Chua Rán Hà Nội',
      icon: '🍢',
      costPrice: 14_000,
      sellPrice: 25_000,
      profit: 11_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Đĩa nem chua rán giòn thơm chấm tương ớt',
      region: 'north',
      shelfLife: 'packaged',
    },
    {
      id: 'ca_phe_trung',
      name: 'Cà Phê Trứng Hà Nội',
      icon: '☕',
      costPrice: 12_000,
      sellPrice: 25_000,
      profit: 13_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bọt trứng béo ngậy quện cà phê phin sánh mịn',
      region: 'north',
      shelfLife: 'storable',
    },
    {
      id: 'cacao_dua_dam',
      name: 'Cacao Dừa Dầm Ly Đá',
      icon: '🥥',
      costPrice: 11_000,
      sellPrice: 22_000,
      profit: 11_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Dừa nạo giòn thạch cacao dầm đá mát lạnh',
      region: 'north',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'mi_tom_trung',
      name: 'Mì Ly Ăn Liền Chế Nước',
      icon: '🍜',
      costPrice: 12_000,
      sellPrice: 22_000,
      profit: 10_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Mì ly ăn liền chế nước sôi nhanh gọn cứu đói đêm',
      region: 'north',
      shelfLife: 'packaged',
    },
    {
      id: 'bia_hoi',
      name: 'Bia Hơi Vỉa Hè Thùng Đá',
      icon: '🍺',
      costPrice: 8_000,
      sellPrice: 15_000,
      profit: 7_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bia tươi ướp thùng đá mát lạnh giữ chân khách nhậu',
      region: 'north',
      shelfLife: 'perishable_drink',
    },
  ],
  central: [
    {
      id: 'tra_da_hue',
      name: 'Trà Đá Lá Xanh',
      icon: '🧊',
      costPrice: 1_000,
      sellPrice: 4_000,
      profit: 3_000,
      unlocked: true,
      requiredRep: 0,
      desc: 'Nước chè tươi om ủ lạnh ấm lòng khách đường xa',
      region: 'central',
      shelfLife: 'storable',
    },
    {
      id: 'nuoc_mia_thom',
      name: 'Nước Mía Thơm Lá Dứa',
      icon: '🎋',
      costPrice: 5_000,
      sellPrice: 10_000,
      profit: 5_000,
      unlocked: true,
      requiredRep: 0,
      desc: 'Mía ép thơm quả dứa ngọt thanh mát ruột',
      region: 'central',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'tra_cung_dinh',
      name: 'Trà Cung Đình Thảo Mộc',
      icon: '👑',
      costPrice: 7_000,
      sellPrice: 15_000,
      profit: 8_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Trà thảo mộc thanh nhiệt đóng chai ướp lạnh tao nhã',
      region: 'central',
      shelfLife: 'storable',
    },
    {
      id: 'dau_phong_rang',
      name: 'Đậu Phộng Rang Tỏi Ớt',
      icon: '🥜',
      costPrice: 6_000,
      sellPrice: 12_000,
      profit: 6_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Hũ đậu phộng giòn rụm cay cay vui miệng',
      region: 'central',
      shelfLife: 'packaged',
    },
    {
      id: 'che_hem',
      name: 'Chè Hẻm Cố Đô',
      icon: '🍧',
      costPrice: 8_000,
      sellPrice: 15_000,
      profit: 7_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Ly chè bột lọc bọc heo quay ướp đá độc đáo',
      region: 'central',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'banh_ep_hue',
      name: 'Bánh Ép Huế Nóng Giòn',
      icon: '🫓',
      costPrice: 8_000,
      sellPrice: 15_000,
      profit: 7_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bánh ép mỡ hành thịt trứng giòn thơm đặc sản Huế đóng gói',
      region: 'central',
      shelfLife: 'packaged',
    },
    {
      id: 'ca_phe_muoi',
      name: 'Cà Phê Muối Xứ Huế',
      icon: '🧂',
      costPrice: 8_500,
      sellPrice: 18_000,
      profit: 9_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Vị mặn mà béo ngậy ủ lạnh đặc trưng miền Trung',
      region: 'central',
      shelfLife: 'storable',
    },
    {
      id: 'tra_sam_dua',
      name: 'Trà Sâm Dứa Đà Nẵng',
      icon: '🍵',
      costPrice: 4_000,
      sellPrice: 12_000,
      profit: 8_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Trà sâm dứa thơm lừng ngọt mát giải khát phố biển',
      region: 'central',
      shelfLife: 'storable',
    },
    {
      id: 'tre_tron',
      name: 'Tré Trộn Chợ Hàn',
      icon: '🌶️',
      costPrice: 14_000,
      sellPrice: 25_000,
      profit: 11_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Tré gói rơm chua giòn bóc ăn ngay kèm ớt xiêm',
      region: 'central',
      shelfLife: 'packaged',
    },
    {
      id: 'che_bot_loc',
      name: 'Chè Bột Lọc Heo Quay',
      icon: '🥣',
      costPrice: 11_000,
      sellPrice: 20_000,
      profit: 9_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Vị ngọt mặn độc lạ trứ danh sông Hương',
      region: 'central',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'sua_dau_nanh',
      name: 'Sữa Đậu Nành Nóng',
      icon: '🥛',
      costPrice: 4_500,
      sellPrice: 10_000,
      profit: 5_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Ly sữa đậu béo ngậy ủ nóng ấm lòng đêm phố cổ',
      region: 'central',
      shelfLife: 'storable',
    },
    {
      id: 'mi_quang',
      name: 'Mì Quảng Ếch Trộn',
      icon: '🍜',
      costPrice: 16_000,
      sellPrice: 28_000,
      profit: 12_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Tô mì sợi to đậm đà đậu phộng bánh tráng ăn liền',
      region: 'central',
      shelfLife: 'packaged',
    },
    {
      id: 'bia_la_rue',
      name: 'Bia Larue Kèm Cá Bò',
      icon: '🍺',
      costPrice: 11_000,
      sellPrice: 18_000,
      profit: 7_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bia con cọp phố biển nhậu lai rai cực bén',
      region: 'central',
      shelfLife: 'packaged',
    },
  ],
  south: [
    {
      id: 'ca_phe_sua_da',
      name: 'Cà Phê Sữa Đá Sài Gòn',
      icon: '☕',
      costPrice: 8_000,
      sellPrice: 18_000,
      profit: 10_000,
      unlocked: true,
      requiredRep: 0,
      desc: 'Cà phê vợt đậm đặc pha sẵn ủ lạnh trong ca inox',
      region: 'south',
      shelfLife: 'storable',
    },
    {
      id: 'bac_xiu',
      name: 'Bạc Xỉu Đá 3 Tầng',
      icon: '🥛',
      costPrice: 9_500,
      sellPrice: 20_000,
      profit: 10_500,
      unlocked: true,
      requiredRep: 0,
      desc: 'Nhiều sữa ít cà phê béo ngậy pha sẵn ủ lạnh',
      region: 'south',
      shelfLife: 'storable',
    },
    {
      id: 'tra_tac',
      name: 'Trà Tắc Khổng Lồ',
      icon: '🍊',
      costPrice: 4_500,
      sellPrice: 12_000,
      profit: 7_500,
      unlocked: true,
      requiredRep: 0,
      desc: 'Ca trà tắc chua ngọt đã khát nắng hè Sài Gòn',
      region: 'south',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'nuoc_sam',
      name: 'Nước Sâm Mía Lau Rong Biển',
      icon: '🌿',
      costPrice: 4_500,
      sellPrice: 10_000,
      profit: 5_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Chai nước sâm nấu lá mía lau ướp xô đá mát lạnh',
      region: 'south',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'nuoc_mia_sau_rieng',
      name: 'Nước Mía Sầu Riêng',
      icon: '🎋',
      costPrice: 10_000,
      sellPrice: 18_000,
      profit: 8_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Mía ngọt sầu riêng thơm nức mũi ép sẵn ướp lạnh',
      region: 'south',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'banh_trang_nuong',
      name: 'Bánh Tráng Nướng Đà Lạt',
      icon: '🍕',
      costPrice: 10_000,
      sellPrice: 18_000,
      profit: 8_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Pizza vỉa hè mỡ hành trứng cút thơm nức mũi đóng gói',
      region: 'south',
      shelfLife: 'packaged',
    },
    {
      id: 'tra_dau',
      name: 'Trà Dâu Đông Du',
      icon: '🍓',
      costPrice: 8_500,
      sellPrice: 18_000,
      profit: 9_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Trà đen chua ngọt dâu tây ngâm trào lưu giới trẻ',
      region: 'south',
      shelfLife: 'storable',
    },
    {
      id: 'pha_lau',
      name: 'Phá Lấu Bò Kèm Bánh Mì',
      icon: '🥘',
      costPrice: 16_000,
      sellPrice: 28_000,
      profit: 12_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Nước cốt dừa thơm béo chấm bánh mì nóng giòn',
      region: 'south',
      shelfLife: 'packaged',
    },
    {
      id: 'ca_vien_chien',
      name: 'Cá Viên Chiên Nước Mắm',
      icon: '🍢',
      costPrice: 12_000,
      sellPrice: 22_000,
      profit: 10_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Xiên que chiên vàng giòn sốt mắm tỏi ớt đưa miệng',
      region: 'south',
      shelfLife: 'packaged',
    },
    {
      id: 'cacao_dua_dam',
      name: 'Cacao Dừa Dầm Ly Đá',
      icon: '🥥',
      costPrice: 11_000,
      sellPrice: 22_000,
      profit: 11_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Dừa nạo giòn sần sật thạch cacao béo mát ướp đá',
      region: 'south',
      shelfLife: 'perishable_drink',
    },
    {
      id: 'com_chay',
      name: 'Cơm Cháy Chà Bông Mỡ Hành',
      icon: '🍘',
      costPrice: 11_500,
      sellPrice: 22_000,
      profit: 10_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Cơm cháy giòn rụm ngập chà bông và mỡ hành đóng gói',
      region: 'south',
      shelfLife: 'packaged',
    },
    {
      id: 'kho_bo_den',
      name: 'Đĩa Gỏi Khô Bò Đen',
      icon: '🐮',
      costPrice: 9_500,
      sellPrice: 18_000,
      profit: 8_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bịch khô bò đen đu đủ giòn kèm giấm chua ngọt',
      region: 'south',
      shelfLife: 'packaged',
    },
    {
      id: 'banh_trang_tron',
      name: 'Bánh Tráng Trộn Bệt',
      icon: '🥢',
      costPrice: 10_000,
      sellPrice: 18_000,
      profit: 8_000,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bịch bánh tráng trộn sẵn bò khô trứng cút tiện lợi',
      region: 'south',
      shelfLife: 'packaged',
    },
    {
      id: 'bia_sai_gon',
      name: 'Bia Sài Gòn Lùn Ướp Lạnh',
      icon: '🍺',
      costPrice: 11_500,
      sellPrice: 20_000,
      profit: 8_500,
      unlocked: false,
      requiredRep: 0,
      desc: 'Bia lùn mát lạnh nâng ly cùng anh em chiến hữu',
      region: 'south',
      shelfLife: 'packaged',
    },
  ],
};

export const PROGRESSION_MENU_ITEMS: MenuItem[] = [];

// Default export for backwards compatibility
export const SIDEWALK_MENU: MenuItem[] = REGIONAL_BASE_MENUS.north;

/**
 * Xác định miền dựa theo vĩ độ (latitude)
 */
export function getRegionFromCoordinates(lat: number): RegionKey {
  if (lat >= 19.0) return 'north';
  if (lat >= 13.5) return 'central';
  return 'south';
}

/**
 * Nhận diện loại địa bàn (spot type) từ nhãn địa điểm hoặc tags
 */
export function detectSpotType(label = '', tags: string[] = []): SpotType {
  const text = `${label} ${tags.join(' ')}`.toLowerCase();
  
  if (
    text.includes('hoàn kiếm') ||
    text.includes('bến thành') ||
    text.includes('dinh độc lập') ||
    text.includes('cầu rồng') ||
    text.includes('phố cổ') ||
    text.includes('tourist') ||
    text.includes('chợ') ||
    text.includes('bờ hồ')
  ) {
    return 'tourist';
  }

  if (
    text.includes('trường') ||
    text.includes('đại học') ||
    text.includes('sinh viên') ||
    text.includes('school') ||
    text.includes('học viện')
  ) {
    return 'school';
  }

  if (
    text.includes('văn phòng') ||
    text.includes('công sở') ||
    text.includes('tòa nhà') ||
    text.includes('office') ||
    text.includes('tài chính') ||
    text.includes('phố tài chính')
  ) {
    return 'office';
  }

  return 'residential';
}

/**
 * Sinh thực đơn tùy biến theo toạ độ vùng miền và đặc tính vị trí thực tế (100% thuần chất địa phương)
 */
export function getRegionalMenu(lat: number, _lon = 0, label = '', tags: string[] = []): MenuItem[] {
  const region = getRegionFromCoordinates(lat);
  const spotType = detectSpotType(label, tags);
  const baseItems = REGIONAL_BASE_MENUS[region] ?? REGIONAL_BASE_MENUS.north;

  let priceMultiplier = 1.0;
  let costMultiplier = 1.0;

  switch (spotType) {
    case 'tourist':
      priceMultiplier = 1.25; // Khu du lịch / phố cổ: giá bán cao hơn
      costMultiplier = 1.2;
      break;
    case 'office':
      priceMultiplier = 1.15; // Khu công sở: đồ uống chất lượng, giá khá
      costMultiplier = 1.1;
      break;
    case 'school':
      priceMultiplier = 0.9;  // Cổng trường học: giá mềm, học sinh chuộng
      costMultiplier = 0.85;
      break;
    case 'residential':
    default:
      priceMultiplier = 1.0;
      costMultiplier = 1.0;
      break;
  }

  return baseItems.map((item) => {
    // Làm tròn giá tiền về bội số 1.000đ chuẩn Việt Nam Đồng
    const sellPrice = Math.max(1_000, Math.round((item.sellPrice * priceMultiplier) / 1_000) * 1_000);
    const costPrice = Math.max(1_000, Math.round((item.costPrice * costMultiplier) / 1_000) * 1_000);
    const profit = Math.max(1_000, sellPrice - costPrice);

    return {
      ...item,
      sellPrice,
      costPrice,
      profit,
    };
  });
}
